import { useOwnTeam } from "@/hooks"
import { useCallback, useState } from "react"

import { Modal } from "@/components/Modal"
import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"
import { completeShare } from "@/services/core"
import { useRoleInfo } from "@/user/session"
import { collectClickShareButton, collectRecallShare } from "@/utils/event"
import PreviewModal from "./Preview"

import styles from "./index.module.scss"

interface Props {
    open: boolean
    onChange: (open: boolean) => void
    onShareComplete?: () => void
}

const CG = require("@/assets/imgs/recall/share/kv.jpg")

const Share: React.FC<Props> = (props) => {
    const { open, onChange, onShareComplete } = props

    const role = useRoleInfo()
    const { data: ownTeam } = useOwnTeam()

    const [previewOpen, setPreviewOpen] = useState(false)

    const handleShare = useCallback(() => {
        setPreviewOpen(true)
        if (role) {
            completeShare("recall").then((res) => {
                if (res.code === 0) onShareComplete?.()
            })
        }
        collectClickShareButton("recall")
    }, [role, onShareComplete])

    return (
        <>
            <button
                type="button"
                className={styles.extraButton}
                onClick={() => {
                    if (role) {
                        collectRecallShare("share_button")
                    }
                    onChange(true)
                }}
            >
                <div className={styles.icon} />
                <div className={styles.textWrapper}>
                    <StrokeText
                        text={i18n.getRecall("panel.share")}
                        fontFamily="Georgia-Bold"
                        fontSize={30}
                        fillColor="#ffffff"
                        borderWidth={4}
                        borderColor="#564426"
                        offsetY={0}
                        padding={4}
                        baselineAligned
                        className={styles.text}
                    />
                </div>
            </button>
            <Modal
                open={open}
                onCancel={() => onChange(false)}
                closeButtonClassName={styles.close}
                contentClassName={styles.share}
                showCancelBtn={false}
                showOkBtn={false}
            >
                <div className={styles.cg}>
                    <img src={CG} alt="cg" className={styles.cgImage} />
                </div>
                {role?.nickName && ownTeam?.code && (
                    <div className={styles.tips}>
                        <div className={styles.nickname}>
                            <StrokeText
                                text={`Dr.${role.nickName}`}
                                fontWeight="bold"
                                fontSize={30}
                                fillColor="#6c461d"
                                borderWidth={3}
                                borderColor="#fffaed"
                                offsetY={0}
                                padding={3}
                                baselineAligned
                                className={styles.text}
                            />
                        </div>
                        <div className={styles.code}>{ownTeam.code}</div>
                    </div>
                )}
                <button
                    type="button"
                    className={styles.button}
                    onClick={handleShare}
                >
                    <StrokeText
                        text={i18n.getRecall("panel.share")}
                        fontFamily="Georgia-Bold"
                        fontSize={48}
                        fillColor="#ffffff"
                        borderWidth={3}
                        borderColor="#564426"
                        offsetY={0}
                        padding={3}
                        baselineAligned
                        className={styles.text}
                    />
                </button>
            </Modal>
            <PreviewModal
                open={previewOpen}
                onCancel={() => setPreviewOpen(false)}
                code={ownTeam?.code}
                nickname={role?.nickName}
                cg={CG}
                onShareComplete={onShareComplete}
            />
        </>
    )
}

export default Share
